/**
 * Hook for grouping workers by zone based on assignments
 */

import { useSyncedStore } from '@syncedstore/react'
import { todoStore } from 'src/store/todo'
import { groupWorkersByZone } from '../utils/filtering'
import type { WorkerZoneAssignment } from '../types'

/**
 * Custom hook to get workers grouped by zone
 * Note: Intentionally NOT memoized to ensure reactive updates from synced store
 *
 * @param selectedTeamId - ID of the currently selected team
 * @param selectedTasks - Array of selected task type IDs for filtering
 * @returns Record mapping zone IDs to arrays of worker zone assignments
 *
 * @example
 * const workersByZone = useWorkersByZone(teamId, ['task-1', 'task-2'])
 * const workersInZone = workersByZone['zone-123'] || []
 */
export const useWorkersByZone = (
  selectedTeamId: string | null,
  selectedTasks: string[]
): Record<string, WorkerZoneAssignment[]> => {
  const state = useSyncedStore(todoStore)

  return groupWorkersByZone(
    state.workerAssignments,
    state.workerAssignmentLogs,
    selectedTeamId,
    selectedTasks
  )
}
